import './App.css';

import { ProgressBar } from 'primereact/progressbar';
import img_pulse from './pulse.gif';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

function PageMarketingV2MonetizeOffer({
    t,
    step,
    setStep,
    offer,
    acceptOffer,
    declineOffer,
}) {
    return (
        <div
            className='mk2-post'
            align='center'
            style={{
                width: '90%',
                marginTop: '1em',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className='mk2-available-ads-dot-red' />
                <div className='mk2-available-ads-dot-orange' />
                <div className='mk2-available-ads-dot-green' />
            </div>
            {
                step == 'offer' &&
                <div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '1em',
                        }}>
                        <div>
                            <img
                                src={offer.creativeURL}
                                width={100}
                                className='mk2-offer-ad-image'
                            />
                        </div>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    src={img_pulse}
                                    width={64}
                                />
                                <div>
                                    Offer
                                </div>
                            </div>
                            <div style={{ fontWeight: 'bold' }}>
                                {offer.price} EUR
                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    padding: '1em',
                                }}
                            >
                                <ProgressBar
                                    value={t}
                                    showValue={false}
                                    style={{
                                        backgroundColor: 'grey',
                                        height: '0.5em',
                                    }}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '1em',
                            }}
                        >

                            <Button
                                icon='pi pi-times'
                                severity='secondary'
                                style={{ marginRight: '0.2em' }}
                                onClick={declineOffer}
                                outlined
                                size='small'
                            />
                            <Button
                                icon='pi pi-check'
                                severity='success'
                                onClick={acceptOffer}
                                outlined
                                size='small'
                            />
                        </div>
                    </div>

                </div>
            }
            {
                step == 'loading' &&
                <div>
                    <ProgressSpinner />
                    <div style={{ margin: '1em' }}>
                        <h3>
                            Getting a new offer...
                        </h3>
                    </div>
                </div>
            }
        </div>
    );
}

export default PageMarketingV2MonetizeOffer;